module.exports = __webpack_public_path__ + "img/3.67f111b9.png";